import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Cms } from '@impact/data';

@Component({
    selector: 'app-insurance-spot',
    template: `
        <div
            class="insurance-spot"
            [class.insurance-spot--active]="activeCompany === insurance.companyName"
            appCircleCheckmark
            [condition]="activeCompany === insurance.companyName"
        >
            <div class="insurance-spot__content insurance-spot__content--left">
                <img *ngIf="insurance.companyLogo?.src" class="insurance-spot__logo" [src]="insurance.companyLogo.src | resolveMediaUrl : { format: 'webp', width: 200 }" loading="lazy" appImageLoadFadeIn />
                <p *ngIf="insurance.companyDescriptionText">
                    {{ insurance.companyDescriptionText }}
                </p>
            </div>

            <div class="insurance-spot__content insurance-spot__content--right">
                <app-rich-text *ngIf="insurance?.promotionalContent" [html]="insurance.promotionalContent"></app-rich-text>
                <div class="insurance-spot__content-item-price" *ngIf="insurance?.priceText">{{ insurance.priceText }}</div>

                <app-button
                    (click)="getClickedCompanyName.emit(insurance.companyName)"
                    [title]="
                        activeCompany === insurance.companyName
                            ? ('checkout.insurance_step____button_option____choosen' | translate)
                            : ('checkout.insurance_step____button_option____choose_this' | translate)
                    "
                    [buttonClass]="'button--primary insurance-spot__content-button'"
                >
                </app-button>
                <p *ngIf="insurance.companyTerms" class="text-small text-secondary no-margin">
                    {{ insurance.companyTerms }}
                </p>
            </div>
        </div>
    `,
})
export class InsuranceSpotComponent {
    @Input() insurance: Cms.InsuranceCompany;
    @Input() activeCompany?: string | null;
    @Output() getClickedCompanyName = new EventEmitter<string>();
}
